<template>
  <v-container class="pa-5 mb-5" light width="100%">
    <v-row justify="space-between">
      <v-col cols="1">
        <v-btn icon @click="$router.go(-1)">
          <v-icon color="blue">
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-container class="pa-5 mb-5">
      <v-row justify="center">
        <v-subheader
          class="text-xl-h4 text-lg-h4 text-md-h5 text-sm-h6"
        >
          {{ formattedSurveyTitle }}
        </v-subheader>
      </v-row>
      <v-row justify="center" class="pa-5">
        本アンケートはJMOOCのプライバシーポリシーに従って取り扱われ、コンテンツの品質を向上させるためだけに使用されます。
      </v-row>
      <v-row justify="start">
        <v-col class="text-center red--text text--lighten-1">
          *必須
        </v-col>
      </v-row>
      <v-row v-if="!sendResponse.isEmpty" justify="start">
        <v-col class="text-center">
          <div
            v-if="sendResponse.isSuccess"
            class="success--text"
          >
            <v-icon color="success">
              mdi-check-circle-outline
            </v-icon>
            {{ sendResponse.content }}
          </div>
          <div v-else class="error--text">
            <v-icon color="error">
              mdi-alert-circle-outline
            </v-icon>
            {{ sendResponse.content }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="pa-5 mb-5" />
    <v-container>
      <v-row v-for="(q, index) in questions" :key="index">
        <v-col v-if="q.questionType === 1">
          <MonoSelector
            :num-text="q.questionNum"
            :question-text="q.questionText"
            :options="q.options"
            :required="q.required"
            @update="binder(index, $event)"
          />
        </v-col>
        <v-col v-if="q.questionType === 2">
          <MultiSelector
            :num-text="q.questionNum"
            :question-text="q.questionText"
            :options="q.options"
            :required="q.required"
            @update="binder(index, $event)"
          />
        </v-col>
        <v-col v-if="q.questionType === 3">
          <TextForm
            :num-text="q.questionNum"
            :question-text="q.questionText"
            :required="q.required"
            @update="binder(index, $event)"
          />
        </v-col>
      </v-row>
    </v-container>

    <SendButton :active="!isSent && isFinished" @send="postAnswers" />
  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store/store'
import repository from '@/store/repository'

import { mapState } from 'vuex'
import MonoSelector from '@/components/pages/survey/MonoSelector.vue'
import MultiSelector from '@/components/pages/survey/MultiSelector.vue'
import TextForm from '@/components/pages/survey/TextForm.vue'
import SendButton from '@/components/pages/survey/SendButton.vue'
import handleApiError from '@/plugins/handleApiError'

export default {
  name: 'Survey',
  components: {
    MonoSelector,
    MultiSelector,
    TextForm,
    SendButton
  },
  data () {
    return {
      questionAnswers: [],
      response: [],
      courseId: 0,
      isAnswerd: [],
      isSent: false,
      courseName: '',
      sendResponse: { isEmpty: true, isSuccess: false, content: '' },
      syllabus: require(`@/assets/courseData/courseSyllabuses/${this.$route.params.courseId}.json`),
      questions: require(`@/assets/survey/${this.$route.params.which}Survey.json`)
    }
  },
  computed: {
    ...mapState(['user']),
    isFinished: function () {
      return !this.isAnswerd.find((q) => !q.answerd)
    },
    formattedSurveyTitle: function () {
      const surveyTitle = this.$route.path.includes('pre') ? '受講前アンケート' : '受講後アンケート'
      return `${this.courseName}${surveyTitle}`
    }
  },
  mounted () {
    this.response = []
    for (let i = 0; i < this.questions.length; i++) {
      const object = {}
      object.questionNum = i + 1
      object.questionType = this.questions[i].questionType
      object.questionAnswer = null
      this.$set(this.response, i, object)
      this.$set(this.isAnswerd, i, {
        num: i + 1,
        answerd: !this.questions[i].required
      })
    }

    const courseData = require('@/assets/courseData/courseCards.json')
    const course = courseData.find(
      (v) => v.systemName === this.$route.params.courseId
    )
    this.courseId = Number(course.courseId)
    this.courseName = this.syllabus.courseTitle
  },
  methods: {
    binder: function (index, event) {
      this.response[index].questionAnswer = event
      this.isAnswerd.find((q) => q.num === index + 1).answerd = true
    },
    moveToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    postAnswers: async function () {
      // URLに`pre`が入っていれば受講前用・そうでなければ受講後用のAPIのURLを格納する
      const reqUrl = (this.$route.path.includes('pre')
        ? process.env.VUE_APP_SEND_PRESURVEY_URL
        : process.env.VUE_APP_SEND_POSTSURVEY_URL)

      const reqBody = {
        pjmUserId: repository.getPjmUserId(),
        cognitoIdToken: repository.getIdToken(),
        cognitoUsername: store.state.username,
        courseId: this.courseId,
        questionAnswers: this.response
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      if (!res.data.errorMessage && res.data.registSuccess === 1) {
        this.sendResponse = {
          isEmpty: false,
          isSuccess: true,
          content: '回答を送信しました。左上の矢印をクリックして、単元一覧ページに戻ってください。'
        }
        this.isSent = true
      } else {
        this.sendResponse = {
          isEmpty: false,
          isSuccess: false,
          content: '送信に失敗しました'
        }
      }
      this.moveToTop()
    }
  }
}
</script>
